import { css } from "styled-components"

export const centerMixin = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const shadowMixin = css`
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 10%);
`
